import { useTranslation } from "react-i18next";
import { RevealOnView } from "../reveal-on-view";

interface AudienceCardProps {
	title: string;
	body: string;
}

function AudienceCard({ title, body }: AudienceCardProps) {
	return (
		<article className="rounded-4xl border border-white/10 bg-white/6 p-7 shadow-[0_24px_70px_-48px_rgba(0,0,0,0.72)] backdrop-blur">
			<h3 className="text-xl font-semibold tracking-[-0.03em] text-white">{title}</h3>
			<p className="mt-3 text-sm leading-7 text-white/68">{body}</p>
		</article>
	);
}

export function AudienceSection() {
	const { t } = useTranslation("marketing");

	const audienceCards = [
		{ title: t("audience_family_title"), body: t("audience_family_body") },
		{ title: t("audience_friends_title"), body: t("audience_friends_body") },
		{ title: t("audience_group_title"), body: t("audience_group_body") },
	];

	return (
		<section id="audience" className="grid scroll-mt-28 gap-10 lg:grid-cols-[0.86fr_1.14fr] lg:items-start">
			<RevealOnView from="left">
				<div>
					<p className="text-sm font-semibold uppercase tracking-[0.24em] text-app-accent-secondary">{t("section_audience_eyebrow")}</p>
					<h2 className="mt-4 text-4xl font-semibold tracking-[-0.06em] text-white sm:text-5xl">{t("section_audience_title")}</h2>
				</div>
			</RevealOnView>
			<div className="grid gap-5 md:grid-cols-3">
				{audienceCards.map((item, index) => (
					<RevealOnView key={item.title} delayMs={index * 50} from="up">
						<AudienceCard title={item.title} body={item.body} />
					</RevealOnView>
				))}
			</div>
		</section>
	);
}
